import { render, staticRenderFns } from "./DialogVisitor.vue?vue&type=template&id=84012c3a&scoped=true"
import script from "./DialogVisitor.vue?vue&type=script&lang=js"
export * from "./DialogVisitor.vue?vue&type=script&lang=js"
import style0 from "./DialogVisitor.vue?vue&type=style&index=0&id=84012c3a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84012c3a",
  null
  
)

export default component.exports